import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "form", "input", "editButton", "status"]
  static values = { updateUrl: String, field: { type: String, default: "greeting" } }

  edit(event) {
    event?.preventDefault()
    this.displayTarget.classList.add("hidden")
    this.editButtonTarget.classList.add("hidden")
    this.formTarget.classList.remove("hidden")
    this.inputTarget.focus()
  }

  cancel(event) {
    event?.preventDefault()
    this.formTarget.classList.add("hidden")
    this.displayTarget.classList.remove("hidden")
    this.editButtonTarget.classList.remove("hidden")
    if (this.hasStatusTarget) this.statusTarget.textContent = ""
  }

  async submit(event) {
    event.preventDefault()
    const formData = new FormData(event.target)

    if (this.hasStatusTarget) this.statusTarget.textContent = "保存中…"

    try {
      const response = await fetch(this.updateUrlValue, {
        method: "PATCH",
        body: formData,
        headers: { Accept: "application/json", "X-CSRF-Token": this.csrfToken() }
      })

      if (response.ok) {
        const data = await response.json()
        const text = (data[this.fieldValue] || "").trim()
        if (text === "") {
          this.displayTarget.innerHTML = '<span class="text-gray-400">未設定</span>'
        } else {
          this.displayTarget.textContent = text
        }
        this.cancel()
      } else {
        if (this.hasStatusTarget) this.statusTarget.textContent = "保存に失敗しました"
      }
    } catch (_e) {
      if (this.hasStatusTarget) this.statusTarget.textContent = "保存に失敗しました"
    }
  }

  csrfToken() {
    const meta = document.querySelector("meta[name='csrf-token']")
    return meta ? meta.content : ""
  }
}
